var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-alert',{attrs:{"title":_vm.title,"type":_vm.type,"effect":_vm.effect,"closable":_vm.closable,"close-text":_vm.closeText,"show-icon":_vm.icon,"center":_vm.center,"description":_vm.des},on:{"close":_vm.close},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._t("title")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }